import type { SystemStyleObject } from "@ui/types";
import { Box } from "@ui/components/layout/box/Box";

interface overlayProps {
    background?: string;
    top?: string | number;
    zIndex?: number;
    sx?: SystemStyleObject;
}
export const Overlay = ({ background = "transparent", zIndex = 1, sx }: overlayProps) => {
    return (
        <Box
            id="OVERLAY"
            sx={
                sx ?? {
                    width: "100%",
                    backgroundColor: background,
                    opacity: "0.5",
                    position: ["fixed", "absolute"],
                    display: ["none", "block"],
                    top: ["100vh", 0],
                    zIndex: zIndex,
                    left: 0,
                    height: "100vh",
                }
            }
        />
    );
};
